import React, { useEffect, useRef, useState } from "react";
import ChatSend from "../../../common/SvgImageView/Send";
import { Box, Paper, TextareaAutosize, Typography } from "@mui/material";
import {
  StyledBorderDiv,
  StyledFlex,
  StyledSpaceBetween,
} from "../../../Styled";
import LableToolTip from "../../../common/LableToolTip";
import { useTranslation } from "react-i18next";
import ChatAddBlack from "../../../assets/images/chat_add_Black.svg";
import { generateUniqueId } from "../../../utils/copytoClipboard";
import { useDispatch } from "react-redux";
import { showToastMsg } from "../../../appStore/actions/global/action";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import RequestApproval from "../../../assets/images/requestApproval.svg";
import filesvg from "../../../assets/images/chats/file_svg.svg";
import googlesvg from "../../../assets/images/chats/google_svg.svg";
import youtubesvg from "../../../assets/images/chats/youtube_svg.svg";
import { CLOUD_STORAGE_PROVIDERS } from "../../../utils/cloudStorageProviders";
import SelectedAttachment from "./SelectedAttachment";
import { ApprovalStatus, MessageType } from "../../../utils/constant";
import SendToAll from "../../../assets/images/sendToAll.svg";
import { fontSizeSchemes } from "../../../assets/commonFunction";
import {
  requestGetGroupRecipient,
  requestgroupMemberDetails,
} from "../../../appStore/actions/ArkchatGroup/action";
import session, { handleSelected } from "../../../utils/helper";

const DrawerInput = ({
  taskData,
  checkedType,
  handleUpdateTaskApproval,
  setUpdateTaskApprovalMsg,
  updateTaskApprovalMsg,
  selectedRecipients,
  actualTimeValue,
  handleClickYouTube,
  setFileAttachment,
  handleClickGoogle,
  handleClickCloudStorage,
  fileAttachment,
  attachment,
  setisTopicOpen,
  setAttachment,
  setReplyParentMsg,
  setTaskModalDeatils,
  setIsTaskUpdateTypeModalOpen,
  handleclickAttherate,
  isTaskUpdateTypeModalOpen,
  setCheckedType,
  setSelectRecipientsDrawerOpen,
  setStepper,
  taskModalDeatils,
  setTaskData,
  setIsTaskTypeModalOpen,
  setSelectedRecipients
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const fileRef = useRef(null);
  const menuRef = useRef(null);
  const [allAttachment, setAllAttachment] = useState([]);
  const [isAttachmentMenuOpen, setAttachmentMenuOpen] = useState(false);
  const [isFileSectionDisabled, setFileSectionDisabled] = useState(false);
  const { selectedGroup } = useAppSelectors();
  const dispatch = useDispatch();
  const sendMenuRef = useRef(null);
  const { currentUserData, groupmemberdetails, groupRecipientDetails } =
    useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseAttachmentMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const combinedLength = fileAttachment?.length + attachment?.length;
    const allFilesData = [...fileAttachment, ...attachment];
    setAllAttachment(allFilesData);

    // Setting the disabled state of the checkbox not more than 5 overall attachment
    setFileSectionDisabled(combinedLength === 5);
  }, [fileAttachment, attachment]);
  //
  const handleFileChange = (e) => {
    setAttachmentMenuOpen(false);
    const files = e.target.files; // Get the selected files
    const maxFiles = 5;
    if (files?.length + attachment.length + fileAttachment.length > maxFiles) {
      e.preventDefault();
      dispatch(showToastMsg(`You can only select up to 5 attachment.`));
      return;
    }

    const fileListWithIds = Array.from(files).map((file) => ({
      id: generateUniqueId(file?.name),
      file: file,
    }));

    setFileAttachment([...fileAttachment, ...fileListWithIds]);
  };

  const handleAttachmentMenu = () => {
    if (selectedGroup) {
      if (setAttachmentMenuOpen) {
        setAttachmentMenuOpen(!isAttachmentMenuOpen);
      }
    }
  };

  const handleCloseAttachmentMenu = () => {
    setAttachmentMenuOpen(false);
  };

  const handleRequestApproval = (title) => {
    if (updateTaskApprovalMsg) {
      const updatedTaskBody = {
        ...taskData,
        task_status: ApprovalStatus?.Approved,
        nhi_nhi:true
      };
      setTaskData(updatedTaskBody);
      const reqbody = {
        group_id: taskData?.group_id,
        target_subscriber_id:
          currentUserData?.activeSubscriber?.id ?? selectedGroup?.subscriberId,
      };
      dispatch(requestgroupMemberDetails(reqbody));
      dispatch(requestGetGroupRecipient(taskData?.group_id));

      setSelectRecipientsDrawerOpen(true);
      setCheckedType("requestApprovalOnTask");
      let taskObject = {
        title: appContent?.KEY296,
        type: MessageType?.Approval,
        subHeader: appContent?.KEY299,
        buttonname: appContent?.KEY300,
        title2: appContent?.KEY296,
        msgType: MessageType?.RequestApprovalOnTask,
      };
      setTaskModalDeatils(taskObject);
      setIsTaskTypeModalOpen(false);
      handleclickAttherate(MessageType?.Approval);
      setStepper("user");
      setIsTaskUpdateTypeModalOpen(false);
      if (!isThreadScreen) {
        handleSelected({
          groupmemberdetails,
          groupRecipientDetails,
          taskData,
          setSelectedRecipients,
          appContent,
          selectedRecipients,
        });
      }
    }
  };

  const taskTypeModalArray = [
    {
      title: appContent?.KEY296,
      icon: RequestApproval,
      onClick: () => handleRequestApproval(),
    },

    {
      title: appContent?.KEY64,
      icon: SendToAll,
      onClick: () => triggerHandelSendFinal(),
    },
  ];

  const handleRemoveAttachment = (attachmentId) => {
    // Remove the file with the specified ID from the state
    const updatedattachment = attachment?.filter(
      (file) => file.id !== attachmentId,
    );
    setAttachment(updatedattachment);
    setReplyParentMsg("");
    const updatedFileattachment = fileAttachment?.filter(
      (file) => file.id !== attachmentId,
    );
    setFileAttachment(updatedFileattachment);

    setAllAttachment([...updatedFileattachment, ...updatedattachment]);
  };

  const triggerHandelSendFinal = () => {
    if (updateTaskApprovalMsg) {
      //checkedType!==""
      setIsTaskUpdateTypeModalOpen(false);
      handleUpdateTaskApproval(taskData);
    }
  };

  const triggerHandelSend = () => {
    if (!checkedType) {
      return;
    }
    if (checkedType === "done") {
      if (taskData?.from?.id === currentUserData?.id) {
        triggerHandelSendFinal();
        return;
      }
      setIsTaskUpdateTypeModalOpen(true);
    } else {
      triggerHandelSendFinal();
    }
  };

  return (
    <>
      <StyledBorderDiv
        style={{
          position: "relative",
          zIndex: 1201,
          backgroundColor: "#ffff",
          marginBottom: "0.6rem",
          padding: "0rem 0.25rem",
        }}
      >
        <TextareaAutosize
          style={{
            width: "100%",
            resize: "vertical",
            border: "none",
            outline: "none",
            lineHeight: "1.25rem",
            padding: "5px 8px",
            fontFamily: "Poppins",
            fontSize: "0.87rem",
            maxHeight: "62vh",
            minHeight: "1.1rem",
            overflow: "auto",
            marginBottom: "0.7rem",
          }}
          minRows={"1"}
          placeholder={appContent?.KEY328}
          //   disabled={!selectedGroup}
          //   value={newMessages}
          onChange={(e) => setUpdateTaskApprovalMsg(e.target.value)}
        />
        {allAttachment?.length > 0 && (
          <Box
            width={"100%"}
            position={"relative"}
            height={"3rem"}
            overflow={"scroll"}
            sx={{
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                width: "1px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "transparent",
              },
            }}
          >
            <SelectedAttachment
              data={allAttachment}
              handleRemoveAttachment={handleRemoveAttachment}
            />
          </Box>
        )}
        <StyledSpaceBetween
          style={{
            width: "100%",
            alignItems: "center",
          }}
        >
          <input
            type="file"
            multiple
            name="file"
            ref={fileRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <StyledFlex>
            <Box position={"relative"} width={"30px"} height={"30px"}>
              {isAttachmentMenuOpen && (
                <Box
                  ref={menuRef}
                  position="absolute"
                  top={"-15.4rem"}
                  right={"-10.5rem"}
                  width={"12.3rem"}
                >
                  <Paper
                    sx={{
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;",
                      padding: "0.7rem 0rem",
                    }}
                  >
                    <Box>
                      <Box
                        p={"0.4rem 1rem"}
                        sx={{
                          cursor: "pointer",
                          pointerEvents: isFileSectionDisabled ? "none" : "",
                        }}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          onClick={() => fileRef.current.click()}
                        >
                          <Box>
                            <Typography>Files</Typography>
                          </Box>
                          <Box>
                            <img src={filesvg} alt="file" />
                          </Box>
                        </Box>
                      </Box>

                      {CLOUD_STORAGE_PROVIDERS.map((provider) => (
                        <Box
                          key={provider.id}
                          mt={"0.7rem"}
                          p={"0.4rem 1rem"}
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            handleCloseAttachmentMenu();
                            handleClickCloudStorage(provider.id);
                          }}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Box>
                              <Typography>{provider.label}</Typography>
                            </Box>
                            <Box>
                              <img
                                src={provider.icon}
                                alt={provider.label}
                                width={16}
                                height={16}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ))}

                      <Box
                        mt={"0.7rem"}
                        p={"0.4rem 1rem"}
                        sx={{ cursor: "pointer" }}
                        onClick={handleClickGoogle}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box>
                            <Typography>Google</Typography>
                          </Box>
                          <Box>
                            <img src={googlesvg} alt="file" />
                          </Box>
                        </Box>
                      </Box>

                      <Box
                        mt={"0.7rem"}
                        p={"0.4rem 1rem"}
                        sx={{ cursor: "pointer" }}
                        onClick={handleClickYouTube}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box>
                            <Typography>Youtube</Typography>
                          </Box>
                          <Box>
                            <img src={youtubesvg} alt="file" />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}
              <LableToolTip title={appContent?.KEY256}>
                <img
                  className="chat-input-icon"
                  src={ChatAddBlack}
                  alt="attachment"
                  onClick={handleAttachmentMenu}
                />
              </LableToolTip>
            </Box>
          </StyledFlex>
          {updateTaskApprovalMsg?.trim() && (
            <StyledFlex>
              <Box
                onClick={checkedType ? triggerHandelSend : undefined}
                className="chat-input-left-icon"
                style={{
                  pointerEvents: checkedType ? "auto" : "none",
                  cursor: checkedType ? "pointer" : "default",
                }}
              >
                <ChatSend
                  color={
                    (updateTaskApprovalMsg && checkedType) ||
                    (selectedRecipients?.selectedInternalRecipients?.length >
                      0 &&
                      checkedType) ||
                    (selectedRecipients?.selectedExternalRecipients?.length >
                      0 &&
                      checkedType)
                      ? null
                      : "#8C8C8C"
                  }
                />
              </Box>
            </StyledFlex>
          )}
        </StyledSpaceBetween>
      </StyledBorderDiv>
      {isTaskUpdateTypeModalOpen && (
        <Box
          position="absolute"
          bottom="2.5rem"
          right="0"
          zIndex={1300}
          ref={sendMenuRef}
        >
          <Paper sx={{ p: 2, minWidth: 200 }}>
            <Box display="flex" flexDirection="column" gap={2}>
              {taskTypeModalArray.map((item, index) => (
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  sx={{ cursor: "pointer" }}
                  key={index}
                  onClick={() => item.onClick(item.title)}
                >
                  <Typography
                    fontSize={fontSizeSchemes.font16}
                    fontWeight={400}
                    sx={{
                      flex: 1,
                      textAlign: "right",
                      paddingTop: "0.3rem",
                      paddingBottom: "0.3rem",
                    }}
                  >
                    {item.title}
                  </Typography>
                  <img
                    src={item.icon}
                    alt={item.title}
                    width={16}
                    height={16}
                  />
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>
      )}
    </>
  );
};

export default DrawerInput;
